import React,{ useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import LogoFallback from "/img/logo.png";
import axios from "axios";

export default function AllEvents({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Events and Activities | University of Creative Technology Chittagong",
}) {
	const [news, setNews] = useState([]);
	const [search, setSearch] = useState("");
	const [filteredNews, setFilteredNews] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	
	const newsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,				
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/all-events", payload);
			const data = response.data.slice(0, 48);
			
			// Loop data (array)
			setNews(response.data || []);
			setFilteredNews(data);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {		
		newsPost();
	}, []);
	
	useEffect(() => {
		let result = news;

		if (search) {
			result = result.filter((n) =>
				n.date.toLowerCase().includes(search.toLowerCase())
			);		
			setFilteredNews(result);
		}
	}, [search, news]);
	
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);

  return (
    <div className="relative bg-gradient-to-r from-[#6BCCF2] to-teal-50 overflow-hidden">
      {/* Hero Section */}
     <section className="relative py-20 text-center overflow-hidden">
        <div className="absolute inset-0 bg-green-100 opacity-40 -skew-y-3"></div>
        <motion.h1
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 text-4xl md:text-5xl font-bold text-[#014864]"
        >
          UCTC <span className="text-amber-700">Events and Activities</span>
        </motion.h1>
        <p className="relative z-10 mt-4 text-gray-700 max-w-2xl mx-auto">
          Our uniform reflects discipline, identity, and modesty — ensuring every
          student represents UCTC with pride.
        </p>
		{/* Decorative bottom wave */}
        <div className="absolute bottom-0 left-0 right-0 -mt-6">
          <svg
            viewBox="0 0 1440 80"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-20"
          >
            <path
              d="M0,32 C240,96 480,0 720,32 C960,64 1200,16 1440,32 L1440 80 L0 80 Z"
              fill="[#014864]"
              opacity="0.92"
            />
          </svg>
        </div>
      </section>
	  
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Latest News</h2>

          {/* Search Box */}
          <input
            type="text"
            placeholder="Search news..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mt-3 md:mt-0 border border-gray-300 rounded-lg px-4 py-2 w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-[[#014864]]"
          />
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredNews.length > 0 ? (
            filteredNews.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden"
              >
                {/* Image */}
                <img
                  src={
                    item.images
                      ? import.meta.env.VITE_API_SOURCE_URL + item.images
                      : "https://via.placeholder.com/400x250?text=No+Image"
                  }
                  alt={item.name}
                  className="w-full h-48 object-cover"
                />

                {/* Content */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                    {item.name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3">
                    {new Date(item.start_date).toLocaleDateString()} To {new Date(item.end_date).toLocaleDateString()}
                  </p>

                  <Link
                    to={`/events/${item.id}`}
                    className="inline-block bg-green-600 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-green-700 transition"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <p className="col-span-4 text-center text-gray-500">
              No news found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
